import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-results-pane iodine-no-scroll-y full-height text-center flex-grow-1 flex-shrink-0" }
const _hoisted_2 = { class: "search-search-results-header-container" }
const _hoisted_3 = { class: "search-search-results-content-container iodine-scrollable-y" }

import SearchResultsHeader from 'components/search/SearchResultsHeader.vue';
import SearchTablePane from 'components/search/SearchTablePane.vue';
import SearchResultsList from 'components/search/SearchResultsList.vue';
import {useSearchStore} from 'stores/search-store';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsPane',
  setup(__props) {

const searchStore = useSearchStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchResultsHeader)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_unref(searchStore).isTableModeSelected)
        ? (_openBlock(), _createBlock(SearchResultsList, { key: 0 }))
        : (_openBlock(), _createBlock(SearchTablePane, { key: 1 }))
    ])
  ]))
}
}

})